var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideboardControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61095 0.326646C8.13419 0.753119 8.13833 1.44959 7.6202 1.88225L3.25128 5.53047L7.66326 9.12649C8.18651 9.55296 8.19065 10.2494 7.67251 10.6821C7.15437 11.1148 6.31017 11.1198 5.78692 10.6933L0.427529 6.32509C-0.0957142 5.89861 -0.0998542 5.20214 0.418282 4.76948L5.72537 0.337854C6.2435 -0.0948102 7.08771 -0.0998284 7.61095 0.326646Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideboardControl);
export default __webpack_public_path__ + "static/media/SideboardControl.0164df54.svg";
export { ForwardRef as ReactComponent };